"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActionCell = void 0;
var react_1 = __importDefault(require("react"));
var storm_ui_1 = require("@amzn/storm-ui");
var ActionCell = function (props) {
    var _a = props.cell.value, mainLabel = _a.mainLabel, ActionComponent = _a.ActionComponent;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(storm_ui_1.Text, null, mainLabel),
        ActionComponent));
};
exports.ActionCell = ActionCell;
